import Bloc from './Bloc.js';
import Types from './Types.js';

export default class GreaterEqual extends Bloc {

	constructor (src, ctx) {

		super("opge", src, ctx);
		this.f = (src, ins) => {
			if (src.spendsTension && src.spendsTension() && this.isTensionAvailabilityCheck() && (!src.ignoresTensionSpendModifiers || !src.ignoresTensionSpendModifiers()))
				ins[1] = src.modifyTensionSpendCost(ins[1]);
			return [ins[0] >= ins[1]];
		};
		this.types = [Types.int, Types.int];
	}

	isTensionAvailabilityCheck () {

		const left = this.referencedBloc(this.rawIn?.[0]);
		if (!left || left.type !== "statusvalue")
			return false;
		const target = left.rawIn?.[0];
		const status = left.rawIn?.[1];
		return status === "tension" && (target === "champion" || target === "this");
	}

	referencedBloc (input) {

		if (!input || typeof input !== "object")
			return null;
		return this.ctx[input.type]?.[input.index];
	}
}
